function Pagination({ page, totalPages, onPageChange }) {
    if (totalPages <= 0) return null;

    const getPageNumbers = () => {
        if (totalPages <= 3) {
            return Array.from({ length: totalPages }, (_, i) => i);
        }

        if (page <= 0) {
            return [0, 1, 2];
        }

        if (page >= totalPages - 1) {
            return [totalPages - 3, totalPages - 2, totalPages - 1];
        }

        return [page - 1, page, page + 1];
    };

    const pageNumbers = getPageNumbers();

    return (
        <div className="pagination">
            <span
                className={`page-num ${page === 0 ? "disabled" : ""}`}
                onClick={() => page !== 0 && onPageChange(0)}
            >
                {"<<"}
            </span>

            <span
                className={`page-num ${page === 0 ? "disabled" : ""}`}
                onClick={() => page > 0 && onPageChange(page - 1)}
            >
                {"<"}
            </span>

            {pageNumbers.map((pageNum) => (
                <span
                    key={pageNum}
                    className={page === pageNum ? "page-num active" : "page-num"}
                    onClick={() => onPageChange(pageNum)}
                >
                    {pageNum + 1}
                </span>
            ))}

            <span
                className={`page-num ${page === totalPages - 1 ? "disabled" : ""}`}
                onClick={() => page < totalPages - 1 && onPageChange(page + 1)}
            >
                {">"}
            </span>

            <span
                className={`page-num ${page === totalPages - 1 ? "disabled" : ""}`}
                onClick={() => page !== totalPages - 1 && onPageChange(totalPages - 1)}
            >
                {">>"}
            </span>
        </div>
    );
}

export default Pagination;